// extracted by mini-css-extract-plugin
module.exports = {"pageName":"Wastage_pageName__2-JvK"};